export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Previous</title>
    <path d="M5.5 3v26" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M6.5 16 26 27.258V4.742L6.5 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);
